import React, {PureComponent} from 'react';
import {render} from 'react-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';

import UsaOutline from "../MapElements/UsaOutline";
import UsaStateBorders from "../MapElements/UsaStateBorders";
import UsaStateShapes from "../MapElements/UsaStateShapes";
import UsaStateLabels from "../MapElements/UsaStateLabels";
import UsaStateCalloutBoxes from "../MapElements/UsaStateCalloutBoxes";
import PatternCrosshatch from "../MapElements/PatternCrosshatch";
import LegendGroup from "../Legend/LegendGroup";

import {TEXT} from "../../../utilities/strings";

import * as Utils from "../../../utilities/utilities";
import {VARIABLES} from "../../../utilities/constants";

/**
 * Component for rendering the national map at the state level for export.
 *
 * This component was created with the sole intent of rendering an html
 * svg chart element offscreen and extracting the svg text for export.
 *
 * @example
 * const svgText = NationalMapExport.renderSvgText(selectedCost, statesData, 850, 750)
 */
export default class NationalMapExport extends PureComponent {

  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    selectedCost: PropTypes.string,
    statesData: PropTypes.array
  }

  /**
   * Static function allows the creation and rendering of this map
   * programmatically offscreen for export.
   *
   * @param selectedCost - selected cost value
   * @param statesData - array of state location data
   * @param width - pixel width to render
   * @param height - pixel height to render
   * @returns {string} - serialized svg text
   */
  static renderSvgText = (selectedCost, statesData, width, height) => {
    const element = document.createElement('div');
    render(
      <NationalMapExport
        selectedCost={selectedCost}
        statesData={statesData}
        width={width}
        height={height}
      />
      , element);

    const svg = element.querySelector('svg');
    return new XMLSerializer().serializeToString(svg)
  }

  render() {
    const {width, height, selectedCost, statesData} = this.props;
    const mapHeight = width * .57
    const mapWidth = width - 10

    const dict = _.keyBy(statesData, VARIABLES.StateID)
    const exportTitle = Utils.getStateExportTitle(selectedCost);
    const exportFootnote = TEXT.state_export_footnote;

    const colorField = Utils.getMapValueProperty(selectedCost);
    const legendField = Utils.getLegendValueProperty(selectedCost);

    return (
      <svg width={width} height={height}>
        <PatternCrosshatch/>

        <rect width={width} height={height} fill="#fff"/>

        <text x={width / 2} y={15} fontWeight="bold" fontFamily="arial,sans-serif" fontSize={17} textAnchor="middle">
          {exportTitle}
        </text>

        <g transform={`translate(0,40)`}>
          <UsaOutline
            width={mapWidth}
            height={mapHeight}
          />
          <UsaStateShapes
            data={statesData}
            dict={dict}
            width={mapWidth}
            height={mapHeight}
            dimension={colorField}
          />
          <UsaStateBorders
            width={mapWidth}
            height={mapHeight}
          />
          <UsaStateLabels
            width={mapWidth}
            height={mapHeight}
            data={statesData}
            dict={dict}
            dimension={colorField}
          />
          <UsaStateCalloutBoxes
            width={mapWidth}
            height={mapHeight}
            data={statesData}
            dict={dict}
            dimension={colorField}
          />
        </g>
        <g transform={`translate(10,${mapHeight + 60})`}>
          <LegendGroup
            data={statesData}
            height={mapHeight}
            width={width-10}
            title={exportTitle}
            footnote={exportFootnote}
            quantileField={colorField}
            valueField={legendField}
          />
        </g>

      </svg>
    );
  }
}
